import {ReportsTableContextProps} from 'modules/reports/components/Table/ReportsTable.context'
import usePrefix from 'modules/reports/hooks/prefix'
import React from 'react'
import {TableRowProps} from 'react-virtualized'
import ReportsTableRowContext from './ReportsTableRow.context'
import ReportsTableCheckbox from '../Checkbox'

type Props = TableRowProps & ReportsTableContextProps

const styles = {
  placeholder: {
    display: 'inline-block',
    width: '128px',
    height: '20px',
    background: '#ddd',
  },
}

function ReportsTableRow(props: Props) {
  const p = usePrefix(props.tablePrefix + '-row')

  const {
    className,
    columns,
    index,
    key,
    onRowClick,
    onRowDoubleClick,
    onRowMouseOut,
    onRowMouseOver,
    onRowRightClick,
    rowData,
    style,
    bag,
  } = props

  const ariaProps: any = {'aria-rowindex': index + 1}
  const eventProps: any = {}

  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    ariaProps['aria-label'] = 'row'
    ariaProps.tabIndex = 0

    if (onRowClick) eventProps.onClick = event => onRowClick({event, index, rowData})
    if (onRowDoubleClick)
      eventProps.onDoubleClick = event => onRowDoubleClick({event, index, rowData})
    if (onRowMouseOut) eventProps.onMouseOut = event => onRowMouseOut({event, index, rowData})
    if (onRowMouseOver) eventProps.onMouseOver = event => onRowMouseOver({event, index, rowData})
    if (onRowRightClick)
      eventProps.onContextMenu = event => onRowRightClick({event, index, rowData})
  }

  const loading = Object.keys(rowData).length === 0

  function handleToggle(checked: boolean) {
    if (checked) bag!.add(rowData)
    else bag!.remove(rowData)
  }

  function renderRow() {
    const selected = Boolean(bag && bag.includes(rowData))

    return (
      <>
        {bag && (
          <ReportsTableCheckbox
            checked={selected}
            onChange={handleToggle}
            data-testid={p('checkbox')}
          />
        )}
        {columns}
      </>
    )
  }

  return (
    <div
      {...ariaProps}
      {...eventProps}
      className={className}
      key={key}
      role="row"
      style={style}
      data-testid={p(index)}
    >
      <ReportsTableRowContext.Provider value={{item: rowData}}>
        {loading ? <div style={styles.placeholder} /> : renderRow()}
      </ReportsTableRowContext.Provider>
    </div>
  )
}

export default ReportsTableRow
